module.exports = __webpack_public_path__ + "static/media/logo-icon.7f279d55.svg";